import React from "react";
import OurResearch from "../Components/OurResearch";

function AboutUs() {
    return (
        <div>
            <OurResearch />
        </div>
    );
}

export default AboutUs;
